import deepmerge from 'deepmerge';

import main from './main';

const kfum = {
  palette: {
    primary: {
      main: '#450702'
    },
    secondary: {
      main: '#FEEBEB'
    }
  }
};

export default deepmerge(main, kfum);
